export default {
  pt: {
    'auth.meuAcessoCard.title': 'Meu acesso',
    'auth.meuAcessoCard.name': 'Nome',
    'auth.meuAcessoCard.email': 'E-mail',
    'auth.meuAcessoCard.profile': 'Perfil',
    'auth.meuAcessoCard.accessType': 'Tipo de acesso',
    'auth.meuAcessoCard.customer': 'Cliente',
    'auth.meuAcessoCard.permissions': 'Permissões',
    'auth.meuAcessoCard.fullAccess': 'Acesso total a todas as áreas do sistema.',
    'auth.meuAcessoCard.noPermissions': 'Nenhuma permissão específica concedida.',
    'auth.meuAcessoCard.role.staffAdmin': 'Administrador',
    'auth.meuAcessoCard.role.staffOperator': 'Operador',
    'auth.meuAcessoCard.role.customerAdmin': 'Administrador do cliente',
    'auth.meuAcessoCard.role.customerOperator': 'Operador do cliente',
  },
  en: {
    'auth.meuAcessoCard.title': 'My access',
    'auth.meuAcessoCard.name': 'Name',
    'auth.meuAcessoCard.email': 'Email',
    'auth.meuAcessoCard.profile': 'Profile',
    'auth.meuAcessoCard.accessType': 'Access type',
    'auth.meuAcessoCard.customer': 'Customer',
    'auth.meuAcessoCard.permissions': 'Permissions',
    'auth.meuAcessoCard.fullAccess': 'Full access to all areas of the system.',
    'auth.meuAcessoCard.noPermissions': 'No specific permissions granted.',
    'auth.meuAcessoCard.role.staffAdmin': 'Administrator',
    'auth.meuAcessoCard.role.staffOperator': 'Operator',
    'auth.meuAcessoCard.role.customerAdmin': 'Customer administrator',
    'auth.meuAcessoCard.role.customerOperator': 'Customer operator',
  },
  es: {
    'auth.meuAcessoCard.title': 'Mi acceso',
    'auth.meuAcessoCard.name': 'Nombre',
    'auth.meuAcessoCard.email': 'Correo electrónico',
    'auth.meuAcessoCard.profile': 'Perfil',
    'auth.meuAcessoCard.accessType': 'Tipo de acceso',
    'auth.meuAcessoCard.customer': 'Cliente',
    'auth.meuAcessoCard.permissions': 'Permisos',
    'auth.meuAcessoCard.fullAccess': 'Acceso total a todas las áreas del sistema.',
    'auth.meuAcessoCard.noPermissions': 'No se concedieron permisos específicos.',
    'auth.meuAcessoCard.role.staffAdmin': 'Administrador',
    'auth.meuAcessoCard.role.staffOperator': 'Operador',
    'auth.meuAcessoCard.role.customerAdmin': 'Administrador del cliente',
    'auth.meuAcessoCard.role.customerOperator': 'Operador del cliente',
  },
}
